export const unscrambleId = (id: string) => id.split('.')[0];
export const getIndustryName = (id: string) => `INDUSTRY_${unscrambleId(id)}`;

export const removeSpecialCharsAndAccents = (str: string) =>
  str
    .normalize('NFD')
    .replace(/[^a-zA-Z0-9]/g, '-')
    .replace(/[\u0300-\u036f]/g, '');
